<template>
	<div id="page-dashboard" class="vx-card p-8 pt-8">

      <!-- Cards Info-->
      <div id="count-mail-card" class="mb-2 pl-3" v-if="$route.fullPath.includes('admin')">
        <div class="vx-row block sm:flex">
          <div class="vx-col flex items-center justify-center mb-2" v-for="(item,index) in listCard" :key="index + item.value + item.label">
			<vx-card class="vx-col flex items-center justify-center">
				<h5>{{item.label}}</h5>
				<span class="flex items-center justify-center" >{{item.count}}件</span>
			</vx-card>
          </div>
        </div>
      </div>
	  <div class="mt-5" v-else>
		  <vs-row vs-justify="space-between">
			  <vs-col vs-w="5">
                  	<label class="text-xl">対象期間：</label>
            		<div v-for="(item,index) in typeTimeTargetOptions" :key="index" style="margin-top: 5px">
						<vs-row>
							<vs-col vs-w="2" class="mt-2">
								<input type="radio" v-model="typeTimeTarget" :value="item" class="mr-3"/>
            					<span>{{item}}</span>
							</vs-col>
							<vs-col vs-w="10">
								<v-select
									v-if="item == '月別'"
									class="vx-col w-full"
                    				v-model="monthlyTarget"
                    				:options="monthlyTargetOptions"
									:reduce="monthlyTargetOptions => monthlyTargetOptions.value">
          						</v-select>
								<div v-else class="w-full mb-10">
									<vs-row>
										<vs-col vs-w="5.5">
          									<label class="text-sm opacity-75">お問い合わせ日（から）</label>
											<flat-pickr
												name="お問い合わせ日（から）"
												v-validate.immediate="'required'"
                      							class="w-full flatpickr-style"
                      							v-model="timeFrom"
                      							placeholder="..."
                      							:config="configDate">
          									</flat-pickr>
											<span v-show="typeTimeTarget == '期間指定' && validate && !timeFrom" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("お問い合わせ日（から）") | convertError }}</span>

										</vs-col>
										<vs-col vs-w="1"></vs-col>
										<vs-col vs-w="5.5">
          									<label class="text-sm opacity-75">お問い合わせ日（まで）</label>
											<flat-pickr
												name="お問い合わせ日（まで）"
												v-validate.immediate="'required'"
                      							class="w-full flatpickr-style"
                      							v-model="timeTo"
                      							placeholder="..."
                      							:config="configDate">
          									</flat-pickr>
											<span v-show="typeTimeTarget == '期間指定' && validate && !timeTo" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("お問い合わせ日（まで）") | convertError }}</span>
										</vs-col>
									</vs-row>
								</div>
							</vs-col>
						</vs-row>
					</div>
					<div class="mb-6">
						<label class="text-xl">方法：</label>
						<vs-radio class="mx-2" v-model="typeDashboard" vs-name="typeDashboard" :vs-value="0">メール</vs-radio>
						<vs-radio class="mx-2" v-model="typeDashboard" vs-name="typeDashboard" :vs-value="1">電話</vs-radio>
					</div>
					<div v-if="typeDashboard === TYPE_DASHBOARD_MAIL">
						<label class="text-xl">対象メールアドレス：</label>
						<v-select
							id="mailBoxTarget"
							name="対象メールアドレス"
							v-validate.immediate="'required'"
							item-text="label"
							class="vx-col sm:w-3/4 w-full"
							v-model="mailBoxTarget"
							:options="listMailBoxOptions"
							:reduce="listMailBoxOptions => listMailBoxOptions.value">
						</v-select>
						<span class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("対象メールアドレス") | convertError }}</span>
					</div>
					<div v-else>
						<label class="text-xl">電話名称：</label>
						<v-select
							id="telephoneTarget"
							name="対象メールアドレス"
							v-validate.immediate="'required'"
							class="vx-col sm:w-3/4 w-full"
							v-model="telephoneTarget"
							:options="listTelephoneOptions"
							:reduce="listTelephoneOptions => listTelephoneOptions.value">
						</v-select>
						<span class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("対象メールアドレス") | convertError }}</span>
					</div>

			  </vs-col>
			  <vs-col vs-w="5" v-if="typeDashboard === TYPE_DASHBOARD_MAIL">
                	<label class="text-xl">対象フォルダ：</label>
					<div style="overflow-y:scroll; height:150px;">
						<div v-for="(folder,index) in folderTargetOptions" :key="index" style="margin-top: 5px;">
                  	  		<vs-checkbox v-model="folderTarget" :vs-value="folder.id" class="mx-1 pb-1">{{folder.name}}</vs-checkbox>
				  		</div>
					</div>
			  </vs-col>
		  </vs-row>
		  <vs-row class="mt-5">
			  <vs-col vs-w="5" v-if="typeDashboard === TYPE_DASHBOARD_MAIL">
				<label class="text-xl">対象項目：</label>
					<v-select
						name="対象項目"
						v-validate.immediate="'required'"
						class="vx-col sm:w-3/4 w-full"
                    	v-model="itemTarget"
                    	:options="itemTargetOptions"
						:reduce="itemTargetOptions => itemTargetOptions.value">
          			</v-select>
					<span class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("対象項目") | convertError }}</span>
			  </vs-col>
			  <vs-col vs-w="5" v-else>
				<label class="text-xl">対象項目：</label>
					<v-select
						name="対象項目"
						v-validate.immediate="'required'"
						class="vx-col sm:w-3/4 w-full"
                    	v-model="itemTelephoneTarget"
                    	:options="itemTelephoneTargetOptions"
						:reduce="itemTelephoneTargetOptions => itemTelephoneTargetOptions.value">
          			</v-select>
					<span class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("対象項目") | convertError }}</span>
			  </vs-col>
		  </vs-row>
		  <!-- Chart -->
		  <vs-row class="mt-10" vs-justify="space-between" style="margin-bottom:0px;">
				<vue-json-to-csv ref="exportCSV" style="display: none" :csv-title="titleCSV" :labels="labelExport" :json-data="dataExport"></vue-json-to-csv>
			  	<vs-col vs-w="4">
				  <vs-row vs-type="flex"
                		vs-align="flex-end"
                		vs-justify="flex-end">
                	<vs-button v-if="dataBarChart && dataBarChart.length > 0 && dataBarChart.find(({data}) => data && data.some(value => value > 0))" color="#1976d2" icon="file_download" @click="onExportCSV">CSV出力</vs-button>
				</vs-row>
				<vs-row>
					<vs-col>
						<PieChart
							:dataPieChart="dataPieChart"
							:colorScheme="colorScheme"
							:reload="reloadChart"
						/>
					</vs-col>
				</vs-row>
			  </vs-col>
			  <vs-col vs-w="7" >
					<vs-row vs-type="flex"
                			vs-align="flex-end"
                			vs-justify="flex-end">
                		<vs-button v-if="dataBarChart && dataBarChart.length > 0 && dataBarChart.find(({data}) => data && data.some(value => value > 0))" color="#1976d2" icon="file_download" @click="onExportCSV">CSV出力</vs-button>
					</vs-row>
					<vs-row>
						<vs-col>
							<BarChart
						  		v-show="dataBarChart && dataBarChart.length > 0 && dataBarChart.find(({data}) => data && data.some(value => value > 0))"
						  		:label="labelBarChart"
								:dataBarChart="dataBarChart"
								:reload="reloadChart"
				  			/>
						</vs-col>
						<div v-show="!dataBarChart || dataBarChart.length == 0 || dataBarChart.find(({data}) => !data || data.every(value => value == 0))">
			  				<span style="display: inline-block;">表示するデータがありません</span>
						</div>
					</vs-row>
			  </vs-col>
		  </vs-row>
	  </div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import VxCard from '../components/vx-card/VxCard.vue';
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import VChart from "vue-echarts";
import PieChart from "../components/chart/PieChart.vue";
import BarChart from "../components/chart/BarChart.vue";
import {getLS} from "../utils/localStorage-utils";

const TYPE_DASHBOARD_MAIL = 0
const TYPE_DASHBOARD_TELEPHONE = 1

export default {
  components: {
	  VxCard,
	  vSelect,
	  flatPickr,
	  Japanese,
	  VChart,
	  PieChart,
	  BarChart,
	},
	data() {
		return{
			TYPE_DASHBOARD_MAIL,
			TYPE_DASHBOARD_TELEPHONE,
			listCard: [
				// {value: -1, label: '削除'},
				{value: 0, label: '未対応', count: 0},
				{value: 1, label: '対応中', count: 0},
				{value: 2, label: '返信済（回答待ち)', count: 0},
				{value: 3, label: '返信済', count: 0},
				{value: 4, label: '完了', count: 0}
			],
			listInquiryType: [
        		{
        		  	label: "メール",
        		  	value: "0",
				  	total:0,
        		},
        		{
        		  	label: "電話",
        		  	value: "1",
				  	total:0,
        		},
        		{
        		  	label: "営業",
        		  	value: "2",
				  	total:0,
        		},
        		{
        		  	label: "その他",
        		  	value: "9",
				  	total:0,
        		},
      		],
      		listStateFlag: [
      		  	{
      		  	  	value: 0,
      		  	  	label: "未対応",
			  	  	total:0,
      		  	},
      		  	{
      		  	  	value: 1,
      		  	  	label: "対応中",
					total:0,
      		  	},
      		  	{
      		  	  	value: 2,
      		  	  	label: "返信済（回答待ち）",
					total:0,
      		  	},
      		  	{
      		  	  	value: 3,
      		  	  	label: "返信済",
					total:0,
      		  	},
      		  	{
      		  	  	value: 4,
      		  	  	label: "完了",
					total:0,
      		  	},
      		],
			listType: [],
			listUser: [],
			listUserTelephone: [],
			listKinds: [],
			listStatus: [],
			validate: false,
			typeDashboard: 0,
			typeTimeTargetOptions: ["月別","期間指定"],
			typeTimeTarget: "月別",
			monthlyTarget: "",
			configDate: {
        		locale: Japanese,
        		wrap: true,
        		defaultHour: 0,
        		maxDate: "",
      		},
			timeFrom: null,
			timeTo: null,
			mailBoxTarget: "",
			telephoneTarget: "",
			lastfolderTarget: [],
			folderTarget: [],
			folderTargetOptions: [],
			itemTarget: "state_flg",
			itemTelephoneTarget: "mst_status_id",
			itemTargetOptions:[
				{
					label: "状態",
					value: "state_flg",
				},
				{
					label: "方法",
					value: "inquiry_type",
				},
				{
					label: "種別",
					value: "type",
				},
				{
					label: "担当者",
					value: "mst_user_id",
				}
			],
			itemTelephoneTargetOptions:[
				{
					label: "状態",
					value: "mst_status_id",
				},
				{
					label: "種別",
					value: "mst_kinds_id",
				},
				{
					label: "担当者",
					value: "mst_user_id",
				}
			],
			reloadChart: "",
			dataPieChart: [],
			//105 colors
			colorScheme: [
    			"#1ABC9C","#2ECC71","#3498DB","#9B59B6","#34495E",
    			"#F1C40F","#E67E22","#E74C3C","#ECF0F1","#95A5A6",
    			"#FEA47F","#25CCF7","#EAB543","#55E6C1","#CAD3C8",
    			"#F97F51","#1B9CFC","#F8EFBA","#58B19F","#2C3A47",
    			"#B33771","#3B3B98","#FD7272","#9AECDB","#D6A2E8",
    			"#6D214F","#182C61","#FC427B","#BDC581","#82589F",
    			"#FFC312","#C4E538","#12CBC4","#FDA7DF","#ED4C67",
    			"#F79F1F","#A3CB38","#1289A7","#D980FA","#B53471",
    			"#EE5A24","#009432","#0652DD","#9980FA","#833471",
				"#EA2027","#006266","#1B1464","#5758BB","#6F1E51",
				"#00A8FF","#9C88FF","#FBC531","#4CD137","#487EB0",
				"#0097E6","#8C7AE6","#E1B12C","#44BD32","#40739E",
				"#E84118","#F5F6FA","#7F8FA6","#273C75","#353B48",
				"#FF9FF3","#FECA57","#FF6B6B","#48DBFB","#1DD1A1",
				"#F368E0","#FF9F43","#EE5253","#0ABDE3","#10AC84",
				"#00D2D3","#54A0FF","#5F27CD","#C8D6E5","#576574",
				"#01A3A4","#2E86DE","#341F97","#8395A7","#222F3E",
				"#CD84F1","#FFCCCC","#FF4D4D","#FFAF40","#FFFA65",
				"#C56CF0","#FFB8B8","#FF3838","#FF9F1A","#FFF200",
				"#32FF7E","#7EFFF5","#18DCFF","#7D5FFF","#4B4B4B",
				"#3AE374","#67E6DC","#17C0EB","#7158E2","#3D3D3D",
			],
			labelBarChart: [],
			dataBarChart: [],
			dataExport: [],
            labelExport: {},
			titleCSV: "",
			isCreatedChart: false,
			isSetOptionsComplete: false,
		}
	},
	watch: {
		async typeTimeTarget(){
			if (!this.isSetOptionsComplete) return;
			if ((!this.timeFrom || !this.timeTo) && this.typeTimeTarget == '期間指定'){
				this.validate = true;
				this.dataPieChart = [];
				this.dataBarChart = [];
			} else if (this.typeDashboard == TYPE_DASHBOARD_MAIL){
				await this.getDashBoard();
				await this.renderDataPieChart();
				await this.renderDataBarChart();
			} else {
				await this.getDashBoard();
				await this.renderDataPieChartTelephone();
				await this.renderDataBarChartTelephone();
			}
			this.reloadChart = this.typeTimeTarget;
		},
		async monthlyTarget(){
			if (!this.isSetOptionsComplete) return;
			if (this.typeTimeTarget == '月別'){
				if (this.monthlyTarget && this.typeDashboard === TYPE_DASHBOARD_MAIL){
					await this.getDashBoard();
					await this.renderDataPieChart();
					await this.renderDataBarChart();
				} else if(this.monthlyTarget){
					await this.getDashBoard();
					await this.renderDataPieChartTelephone();
					await this.renderDataBarChartTelephone();
				} else {
					this.dataPieChart = [];
					this.dataBarChart = [];
				}
				this.reloadChart = this.monthlyTarget;
			}	
		},
		async timeFrom(){
			if (!this.isSetOptionsComplete) return;
			if (this.typeTimeTarget == '期間指定'){
				if (!this.timeFrom || !this.timeTo){
					this.validate = true;
					this.dataPieChart = [];
					this.dataBarChart = [];
					} else if (this.typeDashboard == TYPE_DASHBOARD_MAIL){
						await this.getDashBoard();
						await this.renderDataPieChart();
						await this.renderDataBarChart();
					} else {
						await this.getDashBoard();
						await this.renderDataPieChartTelephone();
						await this.renderDataBarChartTelephone();
					}
				this.reloadChart = this.timeFrom;
			}
		},
		async timeTo(){
			if (!this.isSetOptionsComplete) return;
			if (this.typeTimeTarget == '期間指定'){
				if (!this.timeFrom || !this.timeTo){
					this.validate = true;
					this.dataPieChart = [];
					this.dataBarChart = [];
				} else if (this.typeDashboard == TYPE_DASHBOARD_MAIL){
					await this.getDashBoard();
					await this.renderDataPieChart();
					await this.renderDataBarChart();
				} else {
					await this.getDashBoard();
					await this.renderDataPieChartTelephone();
					await this.renderDataBarChartTelephone();
				}
				this.reloadChart = this.timeTo;
			}
		},
		async mailBoxTarget(){
			let listFolder = [];
			this.folderTargetOptions = listFolder;
			if (!this.mailBoxTarget || this.mailBoxTarget == ''){
				this.validate = true;
			} else{
				this.listMailBox.forEach((element) => {
				if (element.id == this.mailBoxTarget && element.subfolder.length > 0){
					element.subfolder.forEach((folder) =>{
						listFolder.push({id:folder.id,name:folder.name});
					})
				}
				})
				//add 受信
				listFolder.unshift({id:0,name:'受信'});
				this.folderTargetOptions = listFolder;
				//Select 受信 (default)
				this.folderTarget = [0]
			}
      await this.getDashBoard();
      await this.renderDataPieChart();
      await this.renderDataBarChart();
		},
		async telephoneTarget(){
			if (!this.isSetOptionsComplete) return;
      await this.getDashBoard();
			await this.renderDataPieChartTelephone();
			await this.renderDataBarChartTelephone();
			this.reloadChart = this.itemTelephoneTarget + this.telephoneTarget
		},
		async folderTarget(){
			if (!this.isSetOptionsComplete) return;
			//If uncheck all => Auto check 受信
			if (this.folderTarget && this.folderTarget.length == 0){
				setTimeout(() => this.folderTarget = this.lastfolderTarget, 0);
			} else{
				this.lastfolderTarget = this.folderTarget;
				await this.renderDataPieChart();
				await this.renderDataBarChart();
			}
			setTimeout(() => this.reloadChart = this.folderTarget, 10);
		},
		async itemTarget(){
			if (!this.isSetOptionsComplete) return;
      await this.getDashBoard();
			await this.renderDataPieChart();
			await this.renderDataBarChart();
			this.reloadChart = this.itemTarget;
		},
		async itemTelephoneTarget(){
			if (!this.isSetOptionsComplete) return;
      await this.getDashBoard();
			await this.renderDataPieChartTelephone();
			await this.renderDataBarChartTelephone();
			this.reloadChart = this.telephoneTarget + this.itemTelephoneTarget;
		},
		async listMailBoxOptions(){
			if (!this.isSetOptionsComplete) return;
			if (!this.isCreatedChart && this.listMailBoxOptions && this.listMailBoxOptions.length > 0){
				await this.getDashBoard();
				await this.renderDataPieChart();
				await this.renderDataBarChart();
				this.reloadChart = this.listMailBoxOptions;
				this.isCreatedChart = true;
			}
		},
		async typeDashboard(value){
			if (!this.isSetOptionsComplete) return;
			if ((!this.timeFrom || !this.timeTo) && this.typeTimeTarget == '期間指定'){
				this.validate = true;
				this.dataPieChart = [];
				this.dataBarChart = [];
			} else if(value == TYPE_DASHBOARD_TELEPHONE){
				await this.getDashBoard();
				await this.renderDataPieChartTelephone();
				await this.renderDataBarChartTelephone();
			} else {
				await this.getDashBoard();
				await this.renderDataPieChart();
				await this.renderDataBarChart();
			}
			this.reloadChart = 'typeDashboard' + this.typeDashboard;
		},
		async isSetOptionsComplete(){
			if ((!this.timeFrom || !this.timeTo) && this.typeTimeTarget == '期間指定'){
			this.validate = true;
			this.dataPieChart = [];
			this.dataBarChart = [];
			} else if (this.typeDashboard == TYPE_DASHBOARD_MAIL){
				await this.getDashBoard();
				await this.renderDataPieChart();
				await this.renderDataBarChart();
			} else {
				await this.getDashBoard();
				await this.renderDataPieChartTelephone();
				await this.renderDataBarChartTelephone();
			}
			this.reloadChart = this.isSetOptionsComplete;
		},
	},
	computed: {
		...mapGetters({
      		listMailBox: "receiveMail/listMailBox",
      		listTelephone: 'telephoneServer/listTelephoneFolder',
			dataDashBoard: "dashBoard/dataDashBoard",
			listTypeDashBoard: "dashBoard/listTypeDashBoard",
			listUserDashBoard: "dashBoard/listUserDashBoard",
			listOptionsDashBoard: "dashBoard/listOptionsDashBoard",
    	}),
		validateForm(){
      		return !this.errors.any()
    	},
		monthlyTargetOptions(){
			let monthlyTargetOptions = [];
			for (let i = 0; i <= 12 ; i++){
				let monthly = new Date();
      			monthly.setMonth(monthly.getMonth() - i);
				let formatMonthlyValue = monthly.toISOString().slice(0,7);
				let formatMonthlyLabel = i > 0 ? i+'ヵ月前('+formatMonthlyValue+')' : '今月('+formatMonthlyValue+')';
				let result = {
					value: formatMonthlyValue,
					label: formatMonthlyLabel
				}
				monthlyTargetOptions.push(result);
				if (i == 0 && (this.monthlyTarget == "" || !this.monthlyTarget)) this.monthlyTarget = result.value;
			}
			return monthlyTargetOptions;
		},
		listMailBoxOptions(){
			let listMailBoxOptions = [];
			let mailBoxTargetId = [];
			if (this.listMailBox && this.listMailBox.length > 0){
				this.listMailBox.forEach((element) => {
					if (!element.read_only_mail_server_id){
						listMailBoxOptions.push({value:element.id,label:element.receive_user_name})
						mailBoxTargetId.push(element.id)
						if (this.mailBoxTarget == "" || !this.mailBoxTarget) this.mailBoxTarget = element.id;
					}
				})
				if(!mailBoxTargetId.includes(this.mailBoxTarget)){
					this.mailBoxTarget = mailBoxTargetId[0];
				}
			}
			return listMailBoxOptions;
		},
		listTelephoneOptions(){
			if(!this.listTelephone || this.listTelephone.length === 0) return []
			return this.listTelephone.map(({ id, name }) => {
				if (this.telephoneTarget == "" || !this.telephoneTarget) this.telephoneTarget = id;
				return { value: id, label: name }
			})
		}
	},
	methods: {
		...mapActions({
			getStatisticMailReceiveState: 'receiveMail/getStatisticMailReceiveState',
			clearSearchFilterReceive: 'receiveMail/clearSearchFilter',
			clearSearchFilterSent: 'mailSent/clearSearchFilter',
      getDataDashBoard: "dashBoard/getDataDashBoard",
			getListTypeDashBoard: "dashBoard/getListTypeDashBoard",
			getListUserDashBoard: "dashBoard/getListUserDashBoard",
      getUnreadNotificationForSys: 'notificationForSys/getUnreadNotificationForSys',
			getListKinds: 'kinds/getListKinds',
			getListStatus: 'status/getListStatus',
			getListUser: 'telephoneServer/getListUserForTelephone',
		}),
		async getDashBoard(){
			let itemTarget = [];
			if(this.typeDashboard == TYPE_DASHBOARD_MAIL) {
				this.itemTargetOptions.forEach((element) =>{
					itemTarget.push(element.value)
				})
			} else {
				this.itemTelephoneTargetOptions.forEach((element) =>{
					itemTarget.push(element.value)
				})
			}
			let list_server_id = []
			if(this.typeDashboard == TYPE_DASHBOARD_MAIL) {
				this.listMailBoxOptions.forEach((element) =>{
					list_server_id.push(element.value);
				})
			} else {
				this.listTelephoneOptions.forEach((element) =>{
					list_server_id.push(element.value);
				})
			}
    		let paramsDashBoard = {
				typeDashboard: this.typeDashboard,
				typeTimeTarget : this.typeTimeTarget == '月別' ? 0 : 1,
				monthlyTarget : this.monthlyTarget,
				timeFrom : this.timeFrom,
				timeTo : this.timeTo,
				itemTarget : [this.itemTarget],
          list_server_id : [this.mailBoxTarget],}
			if (list_server_id && list_server_id.length > 0) await this.getDataDashBoard(paramsDashBoard)
		},
		async setMonthlyTargetCreate(){
			if (this.monthlyTargetOptions.length > 0 && this.monthlyTargetOptions[0].value){
				this.monthlyTarget = this.monthlyTargetOptions[0].value;
			} else{
				let defaultDate = new Date();
    	  		this.monthlyTarget = defaultDate.toISOString().slice(0,7);
			}
		},
		checkFolder(folder){
    	    if (this.folderTarget.find(element => element == folder) >= 0)
    	        return true
    	},
		async refreshListData(){
			this.listInquiryType = [
        		{
        		  	label: "メール",
        		  	value: "0",
				  	total:0,
        		},
        		{
        		  	label: "電話",
        		  	value: "1",
				  	total:0,
        		},
        		{
        		  	label: "営業",
        		  	value: "2",
				  	total:0,
        		},
        		{
        		  	label: "その他",
        		  	value: "9",
				  	total:0,
        		},
      		]
			this.listStateFlag= [
      		  	{
      		  	  	value: 0,
      		  	  	label: "未対応",
			  	  	total:0,
      		  	},
      		  	{
      		  	  	value: 1,
      		  	  	label: "対応中",
					total:0,
      		  	},
      		  	{
      		  	  	value: 2,
      		  	  	label: "返信済（回答待ち）",
					total:0,
      		  	},
      		  	{
      		  	  	value: 3,
      		  	  	label: "返信済",
					total:0,
      		  	},
      		  	{
      		  	  	value: 4,
      		  	  	label: "完了",
					total:0,
      		  	},
      		],
			this.itemTelephoneTargetOptions = [
				{
					label: "状態",
					value: "mst_status_id",
				},
				{
					label: "種別",
					value: "mst_kinds_id",
				},
				{
					label: "担当者",
					value: "mst_user_id",
				}
			]
			if (this.typeDashboard == TYPE_DASHBOARD_TELEPHONE){
				await Promise.all([this.getListStatusSelect(), this.getListUserSelect(), this.getListKindsSelect()])
			}

			let listTypeReceiveMail = []
			if (this.listTypeDashBoard && this.listTypeDashBoard.length > 0){
				this.listTypeDashBoard.forEach((element) =>{
					listTypeReceiveMail.push({label:element.kinds_name,value:element.type_id,total:0});
				})
			}
			this.listType = listTypeReceiveMail;
			let listUserReceiveMail = []
			if (this.listUserDashBoard && this.listUserDashBoard.length > 0){
				this.listUserDashBoard.forEach((element) =>{
					listUserReceiveMail.push({label:element.full_name,value:element.id,total:0});
				})
			}
			listUserReceiveMail.unshift({label:'未設定',value:0,total:0})
			this.listUser = listUserReceiveMail;
		},
		async renderDataPieChart(){
			await this.refreshListData();
    		let dataDashBoard = this.dataDashBoard && this.dataDashBoard[this.itemTarget] && this.dataDashBoard[this.itemTarget][this.mailBoxTarget] ? 
								this.dataDashBoard[this.itemTarget][this.mailBoxTarget] : []
        	let dateKey = dataDashBoard ? Object.keys(dataDashBoard) : [];
			dateKey.forEach((date) =>{
				let folderKey = dataDashBoard[date] ? Object.keys(dataDashBoard[date]) : [];
				folderKey.forEach(async (folder) =>{
					if (this.checkFolder(folder)){
						await this.handleDataPieChart(dataDashBoard[date][folder]);
					}
				})
			})
			this.dataPieChart = []
			if (this.itemTarget == 'state_flg') this.dataPieChart = this.listStateFlag;
			else if (this.itemTarget == 'inquiry_type') this.dataPieChart = this.listInquiryType;
			else if (this.itemTarget == 'type') this.dataPieChart = this.listType;
			else if (this.itemTarget == 'mst_user_id') this.dataPieChart = this.listUser;
		},
		async handleDataPieChart(value){
            let dataChart = [];
            let itemKey = value ? Object.keys(value) : [];
            if (this.itemTarget == 'state_flg') dataChart = this.listStateFlag
            else if (this.itemTarget == 'inquiry_type') dataChart = this.listInquiryType
            else if (this.itemTarget == 'type') dataChart = this.listType
            else if (this.itemTarget == 'mst_user_id') dataChart = this.listUser
            dataChart.forEach((data) =>{
                itemKey.forEach((key) => {
                    if (data.value == key){
                        data.total += value[key]
                    }
                })
            })
            return dataChart
        },
		async renderDataBarChart(){
			let dataChart = [];
            if (this.itemTarget == 'state_flg') dataChart = this.listStateFlag
            else if (this.itemTarget == 'inquiry_type') dataChart = this.listInquiryType
            else if (this.itemTarget == 'type') dataChart = this.listType
            else if (this.itemTarget == 'mst_user_id') dataChart = this.listUser
			this.labelBarChart = [];
			this.dataBarChart = [];
			let data =  this.dataDashBoard && this.dataDashBoard[this.itemTarget] && this.dataDashBoard[this.itemTarget][this.mailBoxTarget] ? 
						this.dataDashBoard[this.itemTarget][this.mailBoxTarget] : [];
			let dateKey = data ? Object.keys(data).sort() : [];
			this.labelBarChart = dateKey;
			let dataSetBarChart = [];
			dataChart.forEach((element) =>{
				let dataElement = {
					label: element.label,
					backgroundColor: this.colorScheme[dataSetBarChart.length],
					data: [],
				}
				dateKey.forEach((date) =>{
					let total = 0;
					let folderKey = data[date] ? Object.keys(data[date]) : [];
					folderKey.forEach((folder) =>{
						if (this.checkFolder(folder)){
							let count = data[date][folder][element.value] ? data[date][folder][element.value] : 0;
							total += count;
						}
					})
					dataElement.data.push(total);
				})
				if (dataElement.data.find(element => element > 0)){
					dataSetBarChart.push(dataElement);
				}
			})
			this.dataBarChart = dataSetBarChart;
		},
		async renderDataBarChartTelephone() {
			let dataBarChart = []
			this.labelBarChart = []
			if (this.itemTelephoneTarget == 'mst_status_id') dataBarChart = this.listStatus;
			else if (this.itemTelephoneTarget == 'mst_kinds_id') dataBarChart = this.listKinds;
			else if (this.itemTelephoneTarget == 'mst_user_id') dataBarChart = this.listUserTelephone;
    		let dataDashBoard = this.dataDashBoard && this.dataDashBoard[this.itemTelephoneTarget] && this.dataDashBoard[this.itemTelephoneTarget][this.telephoneTarget] ?
								this.dataDashBoard[this.itemTelephoneTarget][this.telephoneTarget] : []

			const dates = dataDashBoard.map(({date}) => date)
			this.labelBarChart = [...new Set(dates)].sort()
			const initAcc = this.labelBarChart.map((_) => 0)
			this.dataBarChart = dataBarChart.map(({label, value}, index) => {
				const data = dataDashBoard.reduce((acc, current) => {
					const indexDate = this.labelBarChart.findIndex((date) => date == current.date)
					if(indexDate < 0) return acc
					if(acc[indexDate] >= 0 && value == current[this.itemTelephoneTarget]) {
						acc[indexDate] += current.total
					}
					return acc
				}, [...initAcc])
				return {
					label,
					backgroundColor: this.colorScheme[index],
					data: Object.values(data)
				}
			})
			.filter(({data}) => data.some(value => value > 0))
		},
		async renderDataPieChartTelephone(){
			await this.refreshListData();
			let dataPieChart = []
			if (this.itemTelephoneTarget == 'mst_status_id') dataPieChart = this.listStatus;
			else if (this.itemTelephoneTarget == 'mst_kinds_id') dataPieChart = this.listKinds;
			else if (this.itemTelephoneTarget == 'mst_user_id') dataPieChart = this.listUserTelephone;
    		let dataDashBoard = this.dataDashBoard && this.dataDashBoard[this.itemTelephoneTarget] && this.dataDashBoard[this.itemTelephoneTarget][this.telephoneTarget] ?
								this.dataDashBoard[this.itemTelephoneTarget][this.telephoneTarget] : []

			this.dataPieChart = dataPieChart.map(({ label, value }) => {
				const total = dataDashBoard.reduce((acc, current)  => {
					if(current[this.itemTelephoneTarget] == value && current.total > 0) {
						return acc += current.total
					}
					return acc
				}, 0)
				return { total, label }
			})
		},
		async createTitleCsv(){
			let date = new Date();
			this.titleCSV = 'report_' + (this.typeDashboard == TYPE_DASHBOARD_MAIL ? 'mail' : 'telephone' ) +date.getFullYear()+(date.getMonth()+1)+date.getDate()+date.getHours()+date.getMinutes()+date.getSeconds();
		},
		async onExportCSV(){
			let dataTarget = []
			let labelExport = []
			let dataExport = []
			if(this.typeDashboard == TYPE_DASHBOARD_MAIL) {
				if (this.itemTarget == 'state_flg') dataTarget = this.listStateFlag;
				else if (this.itemTarget == 'inquiry_type') dataTarget = this.listInquiryType;
				else if (this.itemTarget == 'type') dataTarget = this.listType;
				else if (this.itemTarget == 'mst_user_id') dataTarget = this.listUser;
				//Create label csv export
				const label = dataTarget.reduce((a, v) => ({ ...a, [this.itemTarget+v.value]: {title:v.label}}),{})
				labelExport = Object.assign({date: { title: ''}}, label);
				//Create data csv export
				let data = this.itemTarget && this.mailBoxTarget ? this.dataDashBoard[this.itemTarget][this.mailBoxTarget] : [];
				let dateKey = data ? Object.keys(data).sort() : [];
				dateKey.forEach((date) =>{
					let dateExportChild = {};
					dateExportChild.date = date;
					dataTarget.forEach((element)=>{
						let total = 0;
						let folderKey = data[date] ? Object.keys(data[date]) : [];
						folderKey.forEach((folder) =>{
							if (this.checkFolder(folder)){
								let count = data[date][folder][element.value] ? data[date][folder][element.value] : 0;
								total += count;
							}
						})
						dateExportChild[this.itemTarget+element.value] = total;
					})
					dataExport.push(dateExportChild);
				})
			} else {
				const result = await this.onExportCSVTelephone()
				labelExport = result.labelExport
				dataExport = result.dataExport
			}
			await this.createTitleCsv();
			this.$refs.exportCSV.labels = labelExport;
            this.$refs.exportCSV.jsonData = dataExport;
            this.$refs.exportCSV.handleClick();
		},
		async onExportCSVTelephone(){
			let dataTarget = []
			if (this.itemTelephoneTarget == 'mst_status_id') dataTarget = this.listStatus;
			else if (this.itemTelephoneTarget == 'mst_kinds_id') dataTarget = this.listKinds;
			else if (this.itemTelephoneTarget == 'mst_user_id') dataTarget = this.listUserTelephone;
    		let dataDashBoard = this.dataDashBoard && this.dataDashBoard[this.itemTelephoneTarget] && this.dataDashBoard[this.itemTelephoneTarget][this.telephoneTarget] ?
								this.dataDashBoard[this.itemTelephoneTarget][this.telephoneTarget] : []

			const dates = [...new Set(dataDashBoard.map(({date}) => date))].sort()
			let labelExport = dataTarget.reduce((a, v) => ({ ...a, [this.itemTelephoneTarget+v.value]: {title:v.label}}),{date: { title: ''}})
			const initDataExport = dataTarget.reduce((a, v) => ({ ...a, [this.itemTelephoneTarget+v.value]: 0}),{date: ''})
			const dataExport = dates.map(date => {
				let rowExport = { ...initDataExport, date }
				dataDashBoard.forEach((current) => {
					if(current.date == date) {
						rowExport[this.itemTelephoneTarget+current[this.itemTelephoneTarget]] += current.total
					}
				})
				return rowExport
			})

			return { labelExport, dataExport }
		},
		async getListKindsSelect() {
			const response = await this.getListKinds(TYPE_DASHBOARD_TELEPHONE)
			this.listKinds = []
			if (response) {
				const options = response.map(({ id, kinds_name }) => ({
					value: id,
					label: kinds_name
				}))
				this.listKinds = [...this.listKinds, ...options]
			}
		},
		async getListStatusSelect() {
			const data = await this.getListStatus(TYPE_DASHBOARD_TELEPHONE)
			this.listStatus = []
			if (data) {
				const options = data.map(({ id, name }) => ({
					value: id,
					label: name
				}))
				this.listStatus = [...this.listStatus, ...options]
			}
		},
		async getListUserSelect() {
			const response = await this.getListUser(TYPE_DASHBOARD_TELEPHONE)
			this.listUserTelephone = []
			if (response) {
				const options = response.map(({ id, name }) => ({
					value: id,
					label: name
				}))
				this.listUserTelephone = [...this.listUserTelephone, ...options]
			}
		},
		async setOptionsDashBoard() {
			//Get Info User Login
    		let userInfo = JSON.parse(getLS("userInfo"));
      		//Get data options previous dashboard
      		let listOptionsDashBoard = JSON.parse(this.listOptionsDashBoard);
			let optionsOfUser = listOptionsDashBoard.filter(item => item.id == userInfo.id);
			if (optionsOfUser && optionsOfUser.length > 0) {
				optionsOfUser = optionsOfUser[0];
				//Set Options
				this.typeDashboard = optionsOfUser.data.typeDashboard || this.typeDashboard;
				this.typeTimeTarget = optionsOfUser.data.typeTimeTarget || this.typeTimeTarget;
				this.monthlyTarget = optionsOfUser.data.monthlyTarget || this.monthlyTarget;
				this.timeFrom = optionsOfUser.data.timeFrom || this.timeFrom;
				this.timeTo = optionsOfUser.data.timeTo || this.timeTo;
				this.mailBoxTarget = optionsOfUser.data.mailBoxTarget || this.mailBoxTarget;
				this.telephoneTarget = optionsOfUser.data.telephoneTarget || this.telephoneTarget;
				this.lastfolderTarget = optionsOfUser.data.lastfolderTarget || this.lastfolderTarget;
				this.folderTarget = optionsOfUser.data.folderTarget || this.folderTarget;
				this.itemTarget = optionsOfUser.data.itemTarget || this.itemTarget;
				this.itemTelephoneTarget = optionsOfUser.data.itemTelephoneTarget || this.itemTelephoneTarget;
			}
		},
		saveOptionsDashBoard() {
			//Define options
			let options = {
				typeDashboard: this.typeDashboard,
				typeTimeTarget: this.typeTimeTarget,
				monthlyTarget: this.monthlyTarget,
				timeFrom: this.timeFrom,
				timeTo: this.timeTo,
				mailBoxTarget: this.mailBoxTarget,
				telephoneTarget: this.telephoneTarget,
				lastfolderTarget: this.lastfolderTarget,
				folderTarget: this.folderTarget,
				itemTarget: this.itemTarget,
				itemTelephoneTarget: this.itemTelephoneTarget,
			}
			//Get Info User Login
    		let userInfo = JSON.parse(getLS("userInfo"));
      		//Get data options previous dashboard
      		let listOptionsDashBoard = JSON.parse(this.listOptionsDashBoard);
			// Check state of user exist
      		let result = listOptionsDashBoard.filter(item => item.id == userInfo.id);
			let dataOptions = {};
			if (result) {
				if (result.length == 0) {
					//New State
					dataOptions.id = userInfo.id;
					dataOptions.data = options;
				} else {
					//Update State
          			listOptionsDashBoard = listOptionsDashBoard.filter(item => item.id !== userInfo.id)
					dataOptions.id = userInfo.id;
					dataOptions.data = options;
				}
        		listOptionsDashBoard.push(dataOptions);
				//Save state
      			this.$store.commit("dashBoard/SET_LIST_OPTIONS_DASHBOARD", JSON.stringify(listOptionsDashBoard))
			}
		}, 
	},
	async created (){
		/* start loading with many requests */
    	this.$store.dispatch("updateLoads", true);
    	await this.getUnreadNotificationForSys();
		if (!this.$route.fullPath.includes('admin')){
			await this.setMonthlyTargetCreate();
			await this.setOptionsDashBoard();
			let list_server_id = [];
			this.listMailBox.forEach((element) =>{
    		  if (!element.read_only_mail_server_id)
    		    list_server_id.push(element.id);
    		})
			await this.getListTypeDashBoard()
			await this.getListUserDashBoard(list_server_id)
			await this.getListStatusSelect()
			await this.getListUserSelect()
			await this.getListKindsSelect()
		} else{
			await this.getStatisticMailReceiveState()
			.then(response =>{
				response.forEach(element => {
					let index = this.listCard.findIndex(card => card.value == element.state_flg)
					this.listCard[index].count = parseInt(element.numberMail)
				});
			})
		}
		this.isSetOptionsComplete = true;
		/* stop loads */
    	this.$store.dispatch("updateLoads", false);
	},
	mounted () {
		this.clearSearchFilterReceive()
		this.clearSearchFilterSent()
		//mailBox target over width
		let mailBoxTargetCss = document.querySelectorAll('#mailBoxTarget>div>.vs__selected-options');
		if (mailBoxTargetCss && mailBoxTargetCss[0])
			mailBoxTargetCss[0].style.overflow = "hidden";
		window.addEventListener('beforeunload', () => {
			this.saveOptionsDashBoard();
		});
	},
	beforeDestroy() {
      	this.saveOptionsDashBoard();
  	},
}
</script>

<style lang="scss">
#page-dashboard{
	#count-mail-card{
		.vx-row {
			.vx-col{
				height: 60px;
				padding: .2rem;
			}
		}
	}
	.feather-x{
      display: none;
    }
}
</style>